import { createListenerMiddleware } from '@reduxjs/toolkit';
import { analytics, logger, monitoring } from 'common/services';
import { eventApi } from 'store/apis/event';
import { selectUserAccountId } from 'user/api';

import { selectCommunityMemberByCommunityId, selectMyCommunity } from '../api/selectors';
import { setActiveCommunityId } from './communitySlice';
import { setPreferredCommunityId } from './preferredCommunityStorage';

import type { RootState } from 'store';

export const communityListener = createListenerMiddleware<RootState>();

communityListener.startListening({
  actionCreator: setActiveCommunityId,
  effect: () => {
    eventApi.util.invalidateTags(['EVENT']);
  },
});

communityListener.startListening({
  actionCreator: setActiveCommunityId,
  effect: ({ payload }, { getState }) => {
    const accountId = selectUserAccountId(getState());
    if (accountId && payload) {
      logger.info(`Setting preferred community to ${payload}`, { communityId: payload });
      monitoring.trackAction('user.change_preferred_community', { communityId: payload });
      setPreferredCommunityId(accountId, payload);
    }
  },
});

communityListener.startListening({
  actionCreator: setActiveCommunityId,
  effect: (_, { getState }) => {
    const community = selectMyCommunity(getState());
    if (community) {
      monitoring.setContext('community', { id: community.id, slug: community.slug });
    }
  },
});

communityListener.startListening({
  actionCreator: setActiveCommunityId,
  effect: ({ payload }, { getState }) => {
    if (payload) {
      analytics.register('community_id', payload);
    } else {
      analytics.unregister('community_id');
    }

    // Never the role from the community just left. A member record already cached for this one is
    // used now; otherwise its fetch registers the role (`communityApiListener`).
    const role = selectCommunityMemberByCommunityId(getState(), payload ?? undefined)?.communityRole;
    if (role) {
      analytics.register('community_user_role', role);
    } else {
      analytics.unregister('community_user_role');
    }
  },
});
